/**
 * Отладочные логи навигации. Не использует console.*, чтобы не вырезалось при сборке.
 * Включение: в консоли браузера выполнить window.__NAV_DEBUG__ = true
 * После воспроизведения бага: скопировать window.__NAV_LOGS (массив записей с tag и data)
 */
const LOGS_KEY = '__NAV_LOGS';
const DEBUG_KEY = '__NAV_DEBUG__';

export function navLog(tag: string, data?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return;
  const win = window as Window & { [key: string]: unknown };
  if (!win[DEBUG_KEY]) return;
  const logs = (win[LOGS_KEY] as Array<{ t: number; tag: string; data?: Record<string, unknown> }>) ?? [];
  if (!Array.isArray(win[LOGS_KEY])) win[LOGS_KEY] = logs;
  const entry = { t: Date.now(), tag, data };
  logs.push(entry);
  // Оставляем последние 200 записей
  if (logs.length > 200) logs.splice(0, logs.length - 200);
  try {
    if (typeof (window as any).console?.log === 'function') {
      (window as any).console.log('[NAV]', tag, data ?? '');
    }
  } catch {
    // ignore
  }
}
